module.exports = __webpack_public_path__ + "static/media/Manual_PCF_Clientes_v.20.6ed585d2.pdf";